import styled from 'styled-components/macro'

export const TitleContainer = styled.div`
  h3 {
    font-size: 1.5rem;
    color: #224fac;
    margin-bottom: 0.6rem;
    font-family: 'Montserrat';
  }
  p {
    padding-bottom: 0.4rem;
    font-size: 0.7rem;
  }
`

export const TranNum = styled.span`
  padding-left: 0.1rem;
  color: #0097fe;
  font-weight: 600;
`

export const SymbolWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  margin-bottom: 400px;
`
